import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {Avatar, List} from "antd";
import UserCarService from "../../apiServices/UserCarService";
import carInsurance from '../../resources/images/icons/car-insurance-protection.svg'
import {Link} from "react-router-dom";
import {ActivityIndicator, WingBlank} from "antd-mobile";

class ShoppingCart extends Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            userCars: null,
            updateImage: false,
            createOrder: false,
            updateOrder: false,
            updateObject: false,
            carDetail: false,
            objectId: null,
            showLoading: true,
        };
    }

    componentDidMount() {
        UserCarService.list().then(response => {
            this.setState({userCars: response.data, showLoading: false});
        }).catch(function(error){
            console.log(error);
        });
    }

    carDetail = (object_id) => {
        this.props.history.push('/chi-tiet-xe?id='+object_id);
    };

    render() {
        if (this.state.showLoading===true) {
            return (<div className="wrap-content"><ActivityIndicator toast text="Loading..." animating={this.state.showLoading}/></div>);
        }else if(this.state.userCars !== null){
            return (
                <div style={{margin: '0 15px'}}>
                    <List
                        itemLayout="horizontal"
                        dataSource={this.state.userCars}
                        renderItem={item => (
                            <List.Item key={item.id} className='list-carItem'
                               onClick={() => this.carDetail(item.id)}
                            >
                                <List.Item.Meta
                                    avatar={<Avatar src={carInsurance}/>}
                                    title={item.brand+' - '+item.product}
                                    description={item.plate_number}
                                />
                            </List.Item>
                        )}
                    />
                    <div className='boxBuyNow' style={{ marginTop: '10px' }}>
                        <Link to='/them-xe-moi' className="ant-btn btn-next-action">Tạo hồ sơ xe mới</Link>
                    </div>
                </div>
            )
        }else
            return (
                <div style={{ backgroundColor: '#FFFFFF', height: '100%', textAlign: 'center' }}>
                    <WingBlank size="md" className='text-center'>
                        <div style={{ paddingTop: 60, color: '#000000' }}>Bạn chưa có hồ sơ xe nào</div>
                    </WingBlank>
                    <WingBlank size="md" className='text-center'>
                        <img style={{ width: '25%' }} src={require('../../resources/images/icons/car-service.svg')} alt="" />
                    </WingBlank>
                    <div className='boxBuyNow' >
                        <Link to='/them-xe-moi' className="ant-btn btn-next-action">Tạo hồ sơ xe mới</Link>
                    </div>
                </div>
            )
    }
}

export default (withTranslation())(ShoppingCart);